import { jsx as _jsx } from "react/jsx-runtime";
import { Palette } from "@air/next-icons";
import { forwardRef, useState } from "react";
import { CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER } from "~/constants/testIDs";
export const CustomFieldModalColorMenuTrigger = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { selectedColor, fontHex, ...props } = param;
    const [isHovered, setIsHovered] = useState(false);
    return /*#__PURE__*/ _jsx("div", {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        ref: ref,
        className: "absolute left-2 top-1/2 flex size-6 -translate-y-1/2 cursor-pointer items-center justify-center rounded-4 p-0",
        "data-testid": CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER,
        style: {
            backgroundColor: isHovered ? "color-mix(in hsl, ".concat(selectedColor, " 90%, black)") : selectedColor,
            color: fontHex
        },
        ...props,
        children: /*#__PURE__*/ _jsx(Palette, {
            className: "size-4"
        })
    });
});
CustomFieldModalColorMenuTrigger.displayName = "CustomFieldModalColorMenuTrigger";
